import { EXAM_COURSE_ROUTES } from "./examCourseRoutes";
import React from "react";
import { useNavigate } from "react-router-dom";
import "./ExamCoursesCard.css";

const formatPrice = (value) => `Rs. ${Number(value || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;

const ExamCoursesCard = ({ exams = [], masterExam = {}, isLoading = false, error = "" }) => {
  const navigate = useNavigate();

  if (isLoading) return <div className="exam-courses-status">Loading exam courses...</div>;
  if (error) return <div className="exam-courses-status">{error}</div>;
  if (!exams.length) return <div className="exam-courses-status">No courses are available for this master exam.</div>;

  return (
    <div className="subscription-grid">
      {exams.map((item) => (
        <div
          className="subscription-card subscription-card--interactive"
          key={item.exams_id}
          role="button"
          tabIndex={0}
          onClick={() => navigate(EXAM_COURSE_ROUTES.detail, {
            state: {
              exams_id: Number(item.exams_id),
              selectedExam: { id: Number(item.exams_id), name: item.exam_name, image: item.exam_image || masterExam.master_exam_image },
            },
          })}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              navigate(EXAM_COURSE_ROUTES.detail, {
                state: {
                  exams_id: Number(item.exams_id),
                  selectedExam: { id: Number(item.exams_id), name: item.exam_name, image: item.exam_image || masterExam.master_exam_image },
                },
              });
            }
          }}
        >
          <div className="card-top">
            <span><i className="fa-solid fa-users" /></span>
            <div className="price-section">
              <span className="old-price">{formatPrice(item.actual_value)}</span>
              <span className="current-price">{formatPrice(item.value)}</span>
            </div>
          </div>
          <div className="students-count">{Number(item.subscribed_users_count || item.purchase_count || 0).toLocaleString()}+ Student Subscribed</div>
          <h3 className="subscription-title">{item.exam_name}</h3>
          <div className="language-info"><span className="me-1"><i className="bi bi-globe" /></span>{item.available_languages || "Available in English, Hindi"}</div>
          {Number(item.trial_is_enabled) === 1 ? (
            <div className="trial-info">
              {Number(item.trial_is_live_today) === 1 ? <span className="live-badge">LIVE</span> : null}
              <span className="trial-text">Start your trial for {item.trial_duration_name || "a limited time"}</span>
            </div>
          ) : null}
          <div className="card-buttons">
            {(item.available_categories || []).map((category) => <span className="primary-outline-btn" key={category}>{category}</span>)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ExamCoursesCard;
